//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import globalMixin from "@/lib/global";
import vuexMixin from "@/lib/vuexMixin";

export default {
  mixins: [globalMixin, vuexMixin],
  props: {
    preview: {
      type: Boolean,
      default: false,
    },
    admin: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    nomeUsuario() {
      let nameAbbreviations =
        this.me && this.me.fullName && this.me.fullName != ""
          ? this.me.fullName.split(" ")
          : [];
      if (nameAbbreviations.length === 1) {
        return this.me && this.me.name && typeof this.me.name == "string"
          ? this.me.name.substring(0, 2)
          : "";
      } else if (nameAbbreviations.length > 1) {
        return this.me && this.me.name
          ? nameAbbreviations[0]
              .substring(0, 1)
              .concat(nameAbbreviations[1].substring(0, 1))
              .toUpperCase()
          : "";
      }
      return "";
    },
  },
  data: () => ({
    rounded: true,
    expand: false,
  }),
  methods: {
    goTo(path) {
      this.selectedItemMenu = "";
      this.$router.push(path);
    },
  },
};
